<div class="container-fluid">
  <div class="row mh-100vh">
    <div class="col-10 col-sm-8 col-md-6 col-lg-6 offset-1 offset-sm-2 offset-md-3 offset-lg-0 align-self-center d-lg-flex align-items-lg-center align-self-lg-stretch bg-white p-5 rounded rounded-lg-0 my-5 my-lg-0" id="login-block">
      <div class="m-auto register-login w-lg-75 w-xl-50">
        <div class="text-center mb-5"><img src="assets/v2/img/EPC-logo.svg" style="width: 185px;"></div>
        <h2 class="text-center" style="font-size: 20px;line-height: 1.5;margin: 20px auto;">Nouveau mot de passe<br></h2>
        <form [formGroup]="resetPasswordForm" (ngSubmit)="handleValidSubmit($event)" action="#" novalidate>
          <div *ngIf="step == 1">
            <div class="alert alert-danger" *ngIf="submitted && isError">
              Une erreur est survenue lors du traitement de votre demande.
            </div>
            <div class="alert alert-info">
              Le mot de passe doit contenir au minimum 8 caractères, au moins une lettre minuscule et une lettre majuscule, un caractère spécial et un chiffre.
            </div>
            <div class="form-group">
              <input name="newPassword" type="password" formControlName="newPassword" style="height: calc(1.5em + .5rem + 2px) !important;"
                     class="form-control" placeholder="Nouveau mot de passe" pPassword
                     weakLabel="Faible" strongLabel="Fort" mediumLabel="Moyen"
                     [ngClass]="{ 'is-invalid': submitted && f.newPassword.errors }">

              <div *ngIf="submitted && f.newPassword.errors" class="text-danger invalid-feedback">
                <div *ngIf="f.newPassword.errors.required">Mot de passe obligatoire.</div>
                <div *ngIf="f.newPassword.errors.maxlength">Maximum 20 caractères.</div>
                <div *ngIf="f.newPassword.errors.pattern">Format invalide.</div>
              </div>
            </div>
            <div class="form-group">
              <input name="confirmPassword" type="password" formControlName="confirmPassword" style="height: calc(1.5em + .5rem + 2px) !important;"
                     class="form-control" placeholder="Confirmer le nouveau mot de passe" pPassword
                     weakLabel="Faible" strongLabel="Fort" mediumLabel="Moyen"
                     [ngClass]="{ 'is-invalid': submitted && (f.confirmPassword.errors || resetPasswordForm.hasError('notSame')) }">

              <div *ngIf="submitted && (f.confirmPassword.errors || resetPasswordForm.hasError('notSame'))" class="text-danger invalid-feedback">
                <div *ngIf="f.confirmPassword.errors?.required || resetPasswordForm.hasError('notSame')">Confirmer le nouveau mot de passe.</div>
                <div *ngIf="f.confirmPassword.errors?.maxlength">Maximum 20 caractères.</div>
                <div *ngIf="f.confirmPassword.errors?.pattern">Format invalide.</div>
              </div>
            </div>
            <div class="row" style="margin-top: 20px;">
              <div class="col-md-12 col-connect-action">
                <div class="form-group">
                  <button class="btn btn-primary btn-block" type="submit" (click)="handleValidSubmit($event)" style="display: inline-block;">
                    <span class="btn-label">
                      <i class="pi pi-save"></i>
                    </span>Enregistrer
                  </button>
                  <button type="button" class="btn btn-primary btn-block" (click)="redirectToLogin()" style="margin-left: 10px;display: inline-block;">
                    <span class="btn-label">
                      <i class="pi pi-arrow-left"></i>
                    </span>Retour
                  </button>
                </div>
              </div>
            </div>
          </div>
            <div class="row" *ngIf="step == 2">
              <div class="alert alert-success">
                Votre nouveau mot de passe a été pris en compte.
              </div>
              <div class="col-md-12 col-connect-action">
                <button type="button" class="btn btn-primary btn-block" style="width: 100%;" (click)="redirectToLogin()">
                  <span class="btn-label">
                    <i class="pi pi-unlock"></i>
                  </span>Se connecter
                </button>
              </div>
            </div>
</form>
        
        </div>
    </div>
    <div class="col-lg-6 d-flex align-items-end login-bg" id="bg-block">
      <div></div>
    </div>
  </div>
</div>
